import {Component} from 'react';

import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import {setIntl} from '@/libs/intlHelper';

/**
 * Should only use this when not inside a React component (such as redux actions), see:
 * https://github.com/yahoo/react-intl/issues/416
 */
// eslint-disable-next-line import/no-mutable-exports
export let intlGlobal = null;

class IntlGlobalProvider extends Component {
  constructor(props) {
    super(props);
    const {intl} = props;
    intlGlobal = intl;
    setIntl(intl);
  }

  render() {
    const {children} = this.props;
    return children;
  }
}

export default injectIntl(IntlGlobalProvider);

IntlGlobalProvider.propTypes = {
  children: PropTypes.node.isRequired,
  intl: PropTypes.any.isRequired,
};
